import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { sendProductBrandData } from "../../../apis/apis.logistics/apisProduct";
import { toast } from "react-toastify";
import { Modal } from "../../../components/ui";

const initialState = {
    productBrandID: 0,
    name: "",
};

const inputClass =
    "w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";
const labelClass = "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1";

export function ProductBrandForm({ isOpen, onClose }) {
    const { itemProductBrand, brands, setBrands } = useContext(GlobalContext);
    const [item, setItem] = useState(initialState);

    useEffect(() => {
        const productBrandFound = brands.find(
            (item2) => item2.productBrandID === itemProductBrand.productBrandID
        );
        if (productBrandFound) {
            setItem({
                productBrandID: productBrandFound.productBrandID,
                name: productBrandFound.name,
            });
        } else {
            setItem(initialState);
        }
    }, [itemProductBrand, brands]);

    function handleChange(e) {
        setItem({ ...item, [e.target.name]: e.target.value });
    }

    const saveProductBrand = async (data) => {
        try {
            const response = await sendProductBrandData(data);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const updateProductBrands = brands.map((brand) => {
        if (brand.productBrandID === item.productBrandID) {
            const newItem = Object.assign({}, brand);
            newItem.name = item.name;
            return newItem;
        }
        return brand;
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        if (item.productBrandID == 0) {
            saveProductBrand(item).then(async (res) => {
                item.productBrandID = res.productBrandID;
                setItem(item);
                setBrands((prevPlanes) => [...prevPlanes, item]);
                toast.success("Marca registrada con exito!");
            });
        } else {
            setBrands(updateProductBrands);
            saveProductBrand(item);
            toast.success("Marca actualizada con exito!");
        }
        onClose();
    };

    const modalTitle = (
        <>
            <i
                className={`fas ${item.productBrandID ? "fa-edit" : "fa-plus-circle"} text-blue-600 dark:text-blue-400`}
                aria-hidden="true"
            />
            <span>{item.productBrandID ? "Editar Marca" : "Nueva Marca"}</span>
        </>
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={modalTitle} size="sm">
            <input type="hidden" value={item.productBrandID || 0} />

            <div className="mb-6 -mt-2">
                <label className={labelClass}>
                    <i className="fas fa-tag mr-1" aria-hidden="true" />
                    Nombre de la Marca{" "}
                    <span className="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    className={inputClass}
                    placeholder="Ej: Nike, Adidas, Puma..."
                    name="name"
                    maxLength={100}
                    value={item.name || ""}
                    onChange={handleChange}
                    autoFocus
                />
                <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                    <i className="fas fa-info-circle mr-1" aria-hidden="true" />
                    Máximo 100 caracteres
                </p>
            </div>

            <div className="flex flex-wrap justify-end gap-2 border-t border-gray-200 pt-4 dark:border-gray-700">
                <button
                    type="button"
                    onClick={onClose}
                    className="inline-flex items-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                    <i className="fas fa-times mr-1" aria-hidden="true" />
                    Cancelar
                </button>
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="inline-flex items-center rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-green-700"
                >
                    <i
                        className={`fas ${item.productBrandID ? "fa-save" : "fa-plus"} mr-1`}
                        aria-hidden="true"
                    />
                    {item.productBrandID ? "Guardar Cambios" : "Registrar Marca"}
                </button>
            </div>
        </Modal>
    );
}
